import React, { Fragment, useState, useEffect } from 'react';
import styles from './styles';
import './styles.scss';
import * as filters from './filter';
import Header from './Header';
import Toggle from './Toggle';
import Container from './Container';
import useOnclickOutside from 'react-cool-onclickoutside';

import { decorators, Treebeard } from 'react-treebeard';
import IconBox from '../IconBox';
import { MakeClassName } from '../MakeClassName';
import {useTranslation} from "react-i18next";

const TreeViewList = ({ options, defaultValue, resultSearch, setSlectedValue, readOnly, forceForSearch = true }) => {
	useEffect(() => {
		setTypedValue(defaultValue);
	}, [defaultValue]);

	const [data, setData] = useState(options);
	const [cursor, setCursor] = useState({});
	const [typedValue, setTypedValue] = useState(defaultValue);
	const [openResultBox, setOpenResultBox] = useState(false);
	const [isEqual, setIsEqual] = useState(true);
	const {t} = useTranslation()

	const ref = useOnclickOutside(() => {
		if(forceForSearch){
			!isEqual && resultSearch ? setTypedValue('') : setTypedValue(typedValue);

		}
		setData(options);
		setOpenResultBox(false);
	});

	const toggleResultBox = () => {
		setOpenResultBox(!openResultBox);
	};

	const openResultBoxFunc = () => {
		if (!readOnly) {
			setOpenResultBox(true);
		}
	};

	const onToggle = (node, toggled) => {
		if (cursor) {
			setCursor({ ...cursor, active: false });
		}
		node.active = true;
		if (node.children) {
			node.toggled = toggled;
		}

		setCursor(node);
		setData(Object.assign({}, data));
	};
	const onSelect = (node) => {
		setTypedValue(node.name);
		setIsEqual(true);
		setSlectedValue({
			isEqual: true,
			selectedNode: node,
			typedValue: node.name,
		});
		setOpenResultBox(false);
	};
	const onFilterMouseUp = ({ target: { value } }) => {
		const filter = value.trim();

		if (!filter) {
			setSlectedValue({ isEqual: false, selectedNode: null, typedValue: '' });
			setData(options);
			setTypedValue(value);
			setIsEqual(false);
		}
		let filtered = filters.filterTree(options, filter);
		filtered = filters.expandFilteredNodes(filtered, filter);

		let resultObject = filters.isEQualWithNode(options.children, filter);

		setData(filtered);
		setTypedValue(value);
		setIsEqual(resultObject.equalStatus);

		setSlectedValue({
			isEqual: resultObject.equalStatus,
			selectedNode: resultObject.equalNode,
			typedValue: value,
		});
	};

	return (
		<Fragment>
			<div className="tree_box" ref={ref}>
				<div className="search_box">
					<div className="input-group search_box_group">
						<IconBox iconName="searchIcon" specialClass="toggle_icon" clickFunction={toggleResultBox} />
						<input
							className={MakeClassName('form-control filed', true && ' red')}
							type="text"
							onChange={onFilterMouseUp.bind(this)}
							onFocus={openResultBoxFunc}
							value={typedValue}
							readOnly={readOnly}
						/>
					</div>
				</div>
				{openResultBox && (
					<div
						className={MakeClassName(
							'search_result',
							openResultBox && data.children.length === 0 && ' empty_result'
						)}
					>
						<Treebeard
							data={data}
							onToggle={onToggle}
							decorators={{
								...decorators,
								Header,
								Toggle,
								Container,
								onSelect: onSelect,
							}}
							style={styles}
						/>
					</div>
				)}
				{openResultBox && data.children.length === 0 && (
					<div className="empty_box">
						<div className="empty_text">{t('Src.Component.Global.TreeViewList.Index.NothingToShow.Label')}</div>
					</div>
				)}
			</div>
		</Fragment>
	);
};
export default TreeViewList;
